import { Section, Chapter, Experiences } from "../../../../src/pages/amp/_layout";
import { Patterns } from "../../../../src/pages/amp/_patterns";
import { Guidance } from "../../../../src/pages/amp/_guidance";
import pillars from "../../../../src/pages/amp/_assets/Pillars.png";
import pillarsDark from "../../../../src/pages/amp/_assets/Pillars-dark.png";
import identity from "../../../../src/pages/amp/_assets/identity.png";
import identityDark from "../../../../src/pages/amp/_assets/identity-dark.png";
import presence from "../../../../src/pages/amp/_assets/presence.png";
import presenceDark from "../../../../src/pages/amp/_assets/presence-dark.png";
import engagement from "../../../../src/pages/amp/_assets/engagement.png";
import engagementDark from "../../../../src/pages/amp/_assets/engagement-dark.png";
import localSession from "../../../../src/pages/amp/_assets/local.png";
import localSessionDark from "../../../../src/pages/amp/_assets/local-dark.png";
import realTimeEdit from "../../../../src/pages/amp/_assets/real-time-edit.png";
import realTimeEditDark from "../../../../src/pages/amp/_assets/real-time-edit-dark.png";
import workflows from "../../../../src/pages/amp/_assets/workflows.png";
import workflowsDark from "../../../../src/pages/amp/_assets/workflows-dark.png";
import context from "../../../../src/pages/amp/_assets/context.png";
import contextDark from "../../../../src/pages/amp/_assets/context-dark.png";
import conversation from "../../../../src/pages/amp/_assets/conversation.png";
import conversationDark from "../../../../src/pages/amp/_assets/conversation-dark.png";
import video from "../../../../src/pages/amp/_assets/video.png";
import videoDark from "../../../../src/pages/amp/_assets/video-dark.png";
import manageAccess from "../../../../src/pages/amp/_assets/manage-access.png";
import manageAccessDark from "../../../../src/pages/amp/_assets/manage-access-dark.png";
import spaceInstructions from "../../../../src/pages/amp/_assets/space-instructions.png";
import spaceInstructionsDark from "../../../../src/pages/amp/_assets/space-instructions-dark.png";
import audit from "../../../../src/pages/amp/_assets/activity-audit.png";
import auditDark from "../../../../src/pages/amp/_assets/activity-audit-dark.png";
import policies from "../../../../src/pages/amp/_assets/chat-security.png";
import policiesDark from "../../../../src/pages/amp/_assets/chat-security-dark.png";
import * as React from 'react';
export default {
  Section,
  Chapter,
  Experiences,
  Patterns,
  Guidance,
  pillars,
  pillarsDark,
  identity,
  identityDark,
  presence,
  presenceDark,
  engagement,
  engagementDark,
  localSession,
  localSessionDark,
  realTimeEdit,
  realTimeEditDark,
  workflows,
  workflowsDark,
  context,
  contextDark,
  conversation,
  conversationDark,
  video,
  videoDark,
  manageAccess,
  manageAccessDark,
  spaceInstructions,
  spaceInstructionsDark,
  audit,
  auditDark,
  policies,
  policiesDark,
  React
};